
/**
 * @param {string} svg
 */
function convert(svg) {
  svg = [
    '<?xml version="1.0" encoding="utf-8"?>',
    '<!-- Generator: Dow Jones Charts -->',
    '<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">',
    svg
  ].join('\n');
  return new Blob([svg], { type: 'octet/stream' });
}

export default { convert };
